import { Injectable } from '@angular/core';
import { DisplayMessage } from '../../sb-model/display-message';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Begründung: Hilfsklasse zur Verwaltung von Antworten (Replies) auf Nachrichten.
 */
export class ReplyService {
  private readonly replyRequest = new Subject<DisplayMessage>();
  replyRequest$ = this.replyRequest.asObservable();

  insertReplyIntoEditor(message: DisplayMessage): void {
    this.replyRequest.next(message);
  }
}
